/**
 * CustomerIdentification
 * Provides identity validation based off information submitted for specific customer.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AnswerRequestMock { 
    enable: boolean;
    mockType: AnswerRequestMock.MockTypeEnum;
}
export namespace AnswerRequestMock {
    export type MockTypeEnum = 'Success' | 'Failure';
    export const MockTypeEnum = {
        Success: 'Success' as MockTypeEnum,
        Failure: 'Failure' as MockTypeEnum
    };
}


